import { Outlet } from "react-router-dom";
import useDocumentTitle from "hooks/useDocumentTitle";
import { NEUTRAL_ROUTE_TITLES } from "config/routes";

/**
 * NeutralShell is the layout route for screens that are reachable regardless of
 * authentication state, such as invite acceptance and access code redemption.
 */
function NeutralShell() {
  useDocumentTitle(NEUTRAL_ROUTE_TITLES);

  return <Outlet />;
}

export default NeutralShell;
